import * as React from "react";

import specMateResourcesIcon from "../../images/repnet-specmate-resources.webp";
import specMateLogo from "../../images/specmatelogo.webp";
import sdrDatasheetsIcon from "../../images/repnet-sdr-datasheets.webp";
import leadTimesIcon from "../../images/repnet-lead-times.webp";
import orderStatusIcon from "../../images/repnet-order-status.webp";
import aftermarketSupportIcon from "../../images/repnet-aftermarket-support.webp";

interface IQuickAccessLink {
  label: string;
  labelLines: string[];
  url: string;
  icon: string;
}

const quickAccessLinks: IQuickAccessLink[] = [
  {
    label: "SpecMate Resources",
    labelLines: ["SpecMate", "Resources"],
    url: "https://repnet.innoventair.com/my-dashboard/rep-resources/specmate/specmate-resources",
    icon: specMateResourcesIcon
  },
  {
    label: "SDR Datasheets",
    labelLines: ["SDR", "Datasheets"],
    url: "https://repnet.innoventair.com/my-dashboard/rep-resources/specmate/specmate-resources#sdr-datasheets",
    icon: sdrDatasheetsIcon
  },
  {
    label: "Lead Times",
    labelLines: ["Lead", "Times"],
    url: "https://repnet.innoventair.com/my-dashboard/order-management/lead-times",
    icon: leadTimesIcon
  },
  {
    label: "Order Status",
    labelLines: ["Order", "Status"],
    url: "https://repnet.innoventair.com/my-dashboard/order-management/my-orders",
    icon: orderStatusIcon
  },
  {
    label: "Aftermarket Support",
    labelLines: ["Aftermarket", "Support"],
    url: "https://repnet.innoventair.com/my-dashboard/rep-resources/technical-support",
    icon: aftermarketSupportIcon
  }
];

const RepNetQuickAccessRibbon: React.FunctionComponent = () => (
  <section className="repnet-quick-access" aria-labelledby="repnet-quick-access-heading">
    <h2 id="repnet-quick-access-heading">Quick Access</h2>
    <div className="repnet-quick-access-links">
      {quickAccessLinks.map((quickAccessLink) => (
        <a
          className="repnet-quick-access-link"
          href={quickAccessLink.url}
          key={quickAccessLink.label}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={`Open ${quickAccessLink.label} in a new tab`}
        >
          <span className="repnet-quick-access-icon-wrap">
            <img className="repnet-quick-access-icon" src={quickAccessLink.icon} alt="" />
            {quickAccessLink.label === "SpecMate Resources" ? (
              <span className="repnet-specmate-screen" aria-hidden="true">
                <img src={specMateLogo} alt="" />
              </span>
            ) : null}
          </span>
          <span className="repnet-quick-access-label">
            {quickAccessLink.labelLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </span>
        </a>
      ))}
    </div>
  </section>
);

export default RepNetQuickAccessRibbon;
